<template>
    <div>
        <div class="form-group">
            <label>Authentication Key</label>
            <input type="text" class="form-control" v-model="data.authKey">
        </div>
        <div class="form-group">
            <label>Password</label>
            <input type="text" class="form-control" v-model="data.password">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: ['data'],
    data() { return {}; },
};
</script>